import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'docState',
  standalone: false
})
export class DocStatePipe implements PipeTransform {

  transform(state: string | null): {name: string, class: string} {
    switch (state) {
      case 'ValidationPending': {
        return {
          name: 'Pendiente de validación',
          class: 'queued',
        }
      }
      case 'Validated': {
        return {
          name: 'Validado',
          class: 'ready',
        }
      }
      case 'NonValidated': {
        return {
          name: 'Rechazado',
          class: 'error',
        }
      }
      default: {
        return {
          name: 'Sin estado',
          class: 'queued',
        }
      }
    }
  }

}
